import _jsx from '@babel/runtime/helpers/jsx';
import _extends from '@babel/runtime/helpers/extends';
import React, { useContext, forwardRef } from 'react';
import classNames from 'classnames';
import { AndesContext, getPatchedI18n } from '@andes/context';
import ChevronRight20 from '@andes/icons/ChevronRight20';
import ChevronLeft20 from '@andes/icons/ChevronLeft20';
import ChevronRight12 from '@andes/icons/ChevronRight12';
import ChevronLeft12 from '@andes/icons/ChevronLeft12';
const namespace$2 = 'andes-pagination';
function redirectPage(event, page, href, formatUrl, getUrl, handleChange) {
  if (typeof handleChange === 'function') {
    handleChange(event, Number(page));
  }
  window.location = formatUrl ? formatUrl(href, Number(page)) : getUrl(href, Number(page));
}
var _i, _i2, _i3;
const namespace$1 = 'andes-pagination';
const getClassPaginationButton = (page, selectedPage) => classNames("".concat(namespace$1, "__button"), {
  ["".concat(namespace$1, "__button--current")]: page === selectedPage
});
const getUrl$1 = (href, page) => href.replace('$page', String(page));
class PageList extends React.PureComponent {
  render() {
    const {
      paginator,
      handleChange,
      href,
      formatUrl,
      i18n,
      componentLink
    } = this.props;
    const getPageList = paginator.pages.map((page, index) => {
      const currentPage = paginator.selectedPage === page;
      const commonProps = {
        className: "".concat(namespace$1, "__link"),
        'aria-label': i18n.pgettext(namespace$1, 'Ir a la página {0}', page)
      };
      function getComponentRender() {
        if (componentLink === 'button') {
          return /*#__PURE__*/React.createElement("button", _extends({
            "aria-current": currentPage ? 'page' : undefined,
            onClick: e => redirectPage(e, Number(page), href, formatUrl, getUrl$1, handleChange),
            role: "link",
            type: "button"
          }, commonProps), page);
        }
        return /*#__PURE__*/React.createElement("a", _extends({
          "aria-current": currentPage ? 'page' : undefined,
          href: formatUrl ? formatUrl(href, Number(page)) : getUrl$1(href, Number(page)),
          onClick: e => handleChange(e, Number(page))
        }, commonProps), page);
      }
      return Number.isInteger(page) ? /*#__PURE__*/_jsx("li", {
        className: getClassPaginationButton(Number(page), paginator.selectedPage)
      }, page, getComponentRender()) : /*#__PURE__*/_jsx("li", {
        "aria-hidden": true,
        className: "".concat(namespace$1, "__button ").concat(namespace$1, "__dots")
      }, "dot-".concat(index), _i || (_i = /*#__PURE__*/_jsx("i", {
        className: "".concat(namespace$1, "__dot")
      })), _i2 || (_i2 = /*#__PURE__*/_jsx("i", {
        className: "".concat(namespace$1, "__dot")
      })), _i3 || (_i3 = /*#__PURE__*/_jsx("i", {
        className: "".concat(namespace$1, "__dot")
      })));
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, paginator && getPageList);
  }
}
var PageList$1 = PageList;
const SIZE_SMALL = 'small';
var _ChevronRight, _ChevronRight2, _ChevronLeft, _ChevronLeft2;
const namespace = 'andes-pagination';
const className = (disabled, direction) => classNames("".concat(namespace, "__button"), {
  ["".concat(namespace, "__button--").concat(direction)]: direction,
  ["".concat(namespace, "__button--disabled")]: disabled
});
const Title = _ref => {
  let {
    title
  } = _ref;
  return /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace, "__arrow-title")
  }, void 0, title);
};
const getUrl = (href, page) => href.replace('$page', String(page));
const getChevronRight = (size, isMobile) => size === SIZE_SMALL && !isMobile ? _ChevronRight || (_ChevronRight = /*#__PURE__*/_jsx(ChevronRight12, {})) : _ChevronRight2 || (_ChevronRight2 = /*#__PURE__*/_jsx(ChevronRight20, {}));
const getChevronLeft = (size, isMobile) => size === SIZE_SMALL && !isMobile ? _ChevronLeft || (_ChevronLeft = /*#__PURE__*/_jsx(ChevronLeft12, {})) : _ChevronLeft2 || (_ChevronLeft2 = /*#__PURE__*/_jsx(ChevronLeft20, {}));
const ArrowButton = _ref2 => {
  var _Title, _Title2;
  let {
    disabled,
    direction,
    title,
    handleChange,
    href,
    page,
    formatUrl,
    size,
    componentLink
  } = _ref2;
  const {
    device
  } = useContext(AndesContext);
  const isMobile = device === null || device === void 0 ? void 0 : device.mobile;
  function getContent() {
    return direction === 'next' ? /*#__PURE__*/React.createElement(React.Fragment, null, _Title || (_Title = /*#__PURE__*/_jsx(Title, {
      title: title
    })), getChevronRight(size, isMobile)) : /*#__PURE__*/React.createElement(React.Fragment, null, getChevronLeft(size, isMobile), _Title2 || (_Title2 = /*#__PURE__*/_jsx(Title, {
      title: title
    })));
  }
  function getComponentRender() {
    const commonProps = {
      className: "".concat(namespace, "__link"),
      title
    };
    if (componentLink === 'button') {
      return /*#__PURE__*/React.createElement("button", _extends({
        onClick: e => redirectPage(e, Number(page), href, formatUrl, getUrl, handleChange),
        role: "link",
        type: "button"
      }, commonProps), getContent());
    }
    return /*#__PURE__*/React.createElement("a", _extends({
      href: formatUrl ? formatUrl(href, page) : getUrl(href, page),
      onClick: handleChange
    }, commonProps), getContent());
  }
  return /*#__PURE__*/_jsx("li", {
    className: className(disabled, direction)
  }, void 0, getComponentRender());
};
var ArrowButton$1 = ArrowButton;
var module$2 = "@andes/pagination";
var locale$2 = "en-US";
var translations$2 = {
  "andes-pagination\u0004Paginación": [null, "Page layout"],
  "andes-pagination\u0004Anterior": [null, "Previous"],
  "andes-pagination\u0004Siguiente": [null, "Next"],
  "andes-pagination\u0004Ir a la página {0}": [null, "Go to the page {0}"]
};
var enTranslations = {
  module: module$2,
  locale: locale$2,
  translations: translations$2
};
var module$1 = "@andes/pagination";
var locale$1 = "es-AR";
var translations$1 = {
  "andes-pagination\u0004Paginación": [null, "Paginación"],
  "andes-pagination\u0004Anterior": [null, "Anterior"],
  "andes-pagination\u0004Siguiente": [null, "Siguiente"],
  "andes-pagination\u0004Ir a la página {0}": [null, "Ir a la página {0}"]
};
var esTranslations = {
  module: module$1,
  locale: locale$1,
  translations: translations$1
};
var module = "@andes/pagination";
var locale = "pt-BR";
var translations = {
  "andes-pagination\u0004Paginación": [null, "Paginação"],
  "andes-pagination\u0004Anterior": [null, "Anterior"],
  "andes-pagination\u0004Siguiente": [null, "Seguinte"],
  "andes-pagination\u0004Ir a la página {0}": [null, "Vá para a página {0}"]
};
var ptTranslations = {
  module: module,
  locale: locale,
  translations: translations
};
const fillPagesArray = (from, to) => {
  const range = [];
  for (let i = from; i < to; i += 1) {
    range.push(i);
  }
  return range;
};
const appendDotsToPages = range => {
  const rangeWithDots = [...range];
  const areSuccessorsTheFirstTwoEls = range[1] - range[0];
  const areSuccessorsTheLastTwoEls = range[range.length - 1] - range[range.length - 2];
  if (areSuccessorsTheFirstTwoEls !== 1 && areSuccessorsTheFirstTwoEls > 0) {
    rangeWithDots.splice(1, 0, '...');
  }
  if (areSuccessorsTheLastTwoEls !== 1 && areSuccessorsTheLastTwoEls > 0) {
    rangeWithDots.splice(rangeWithDots.length - 1, 0, '...');
  }
  return rangeWithDots;
};
const Pagination = /*#__PURE__*/function () {
  const Pagination = /*#__PURE__*/forwardRef((props, ref) => {
    const {
      'aria-label': ariaLabel,
      srLabel,
      className,
      href,
      formatUrl,
      onChange,
      prevLabel,
      nextLabel,
      pageSelected,
      pageQuantity,
      boundary = 5,
      size = 'large',
      componentLink = 'a'
    } = props;
    const i18n = getPatchedI18n(AndesContext, enTranslations, esTranslations, ptTranslations);
    const selected = pageSelected <= pageQuantity ? pageSelected : pageQuantity;
    const getPagination = () => {
      const currentPage = selected;
      const lastPage = pageQuantity;
      const left = Math.max(currentPage - boundary, 2);
      const right = Math.min(currentPage + boundary + 1, lastPage);
      let range = [1];
      let rangeWithDots = [];
      const firstOnesThreshold = Math.min(lastPage, 10);
      const lastOnesThreshold = lastPage - 8;
      const isPageAmongTheFirstOnes = currentPage < 9;
      const isPageAmongTheLastOnes = currentPage > lastOnesThreshold;
      if (lastPage > 0) {
        if (lastPage === 1) {
          return [1];
        }
        if (isPageAmongTheFirstOnes) {
          range = [...range, ...fillPagesArray(2, firstOnesThreshold)];
        } else if (isPageAmongTheLastOnes) {
          range = [...range, ...fillPagesArray(lastOnesThreshold + 1, lastPage)];
        } else {
          range = [...range, ...fillPagesArray(left, right)];
        }
        range.push(lastPage);
        rangeWithDots = appendDotsToPages(range);
      }
      return rangeWithDots;
    };
    const getPaginator = () => {
      const pages = getPagination();
      return {
        pageQuantity,
        selectedPage: selected,
        hasPreviousPage: pageQuantity > 0 && selected > 1,
        hasNextPage: pageQuantity > 0 && selected + 1 <= Number(pages[pages.length - 1]),
        prevPage: selected - 1,
        nextPage: selected + 1,
        prevLabel: prevLabel || i18n.pgettext(namespace$2, 'Anterior'),
        nextLabel: nextLabel || i18n.pgettext(namespace$2, 'Siguiente'),
        pages
      };
    };
    const handleChange = (e, newPage) => {
      if (typeof onChange === 'function') onChange(e, newPage);
    };
    const paginator = getPaginator();
    const paginationClassNames = classNames(namespace$2, className, {
      ["".concat(namespace$2, "--").concat(size)]: size
    });
    const commonProps = {
      href,
      formatUrl,
      componentLink
    };
    return /*#__PURE__*/React.createElement("nav", {
      ref: ref,
      "aria-label": ariaLabel || srLabel || i18n.pgettext(namespace$2, 'Paginación')
    }, /*#__PURE__*/_jsx("ul", {
      className: paginationClassNames
    }, void 0, /*#__PURE__*/React.createElement(ArrowButton$1, _extends({
      disabled: !paginator.hasPreviousPage,
      direction: "back",
      title: paginator.prevLabel,
      page: paginator.prevPage,
      size: size,
      handleChange: e => handleChange(e, paginator.prevPage)
    }, commonProps)), /*#__PURE__*/React.createElement(PageList$1, _extends({
      paginator: paginator,
      handleChange: handleChange,
      i18n: i18n
    }, commonProps)), /*#__PURE__*/React.createElement(ArrowButton$1, _extends({
      disabled: !paginator.hasNextPage,
      direction: "next",
      title: paginator.nextLabel,
      page: paginator.nextPage,
      size: size,
      handleChange: e => handleChange(e, paginator.nextPage)
    }, commonProps))));
  });
  Pagination.displayName = 'Pagination';
  return Pagination;
}();
var Pagination$1 = Pagination;
export { Pagination$1 as Pagination, Pagination$1 as default };
